import queryString from "query-string";
import {getValueFromStorage, setValueInStorage} from "Helpers/storage";
import {BRAND_NAME, BRAND_THEME} from "Setup/config";

export const MIGRATION_QUERY_PARAM = "migration";
export const MIGRATION_TOKEN_STORAGE_KEY = "migrationToken";

// Brands the migration welcome flow is enabled for; all others ignore the migration param.
export const MIGRATION_ENABLED_BRAND_THEMES = ["jr", "fw"];

// Called once on landing: if the URL carries a ?migration=<token> param, persist it for the session.
export const storeMigrationTokenFromUrl = (search = window?.location?.search) => {
    if (!MIGRATION_ENABLED_BRAND_THEMES.includes(BRAND_THEME)) return;

    const token = queryString.parse(search)?.[MIGRATION_QUERY_PARAM];

    if (token) {
        setValueInStorage(MIGRATION_TOKEN_STORAGE_KEY, token);
    }
};

export const getStoredMigrationToken = () => getValueFromStorage(MIGRATION_TOKEN_STORAGE_KEY);

// The forced-registration path for a stored migration (/:siteCode/welcome/:migrationToken),
// or null when the brand isn't migration-enabled or there is no stored token.
export const getMigrationWelcomePath = () => {
    if (!MIGRATION_ENABLED_BRAND_THEMES.includes(BRAND_THEME)) return null;

    const token = getStoredMigrationToken();
    if (!token) return null;

    const brandPath = BRAND_NAME.replaceAll(" ", "").toLowerCase();

    return `/${brandPath}/welcome/${token}`;
};
